import React from 'react';
import { formatter } from '../../utility';

const RICalcIncreaseBreakdown = (props) => {
  const { 
    calc_p1RemainingEligibleAmount, 
    calc_p1RentAmount, 
    calc_p2MaxCPIAmountStandardRentIncrease, 
    calc_p2MaxRentAmountStandardRentIncrease,
    calc_p2AppliedEligibleAmount,
    calc_p2MaxAdditionalRentIncrease,
    calc_p2MaxEligibleAmount,
    cpiValue,
    cpiYear 
  } = props;


  return (
    <>
      <div className="w1-step-three__increase-breakdown">
        <div className="w1-step-three__wrapper">
          <span className="w1-step-three__value--disabled">{formatter.toAmountDisplay(calc_p1RemainingEligibleAmount)}</span>
          <span className="w1-step-three__label--disabled">Eligible amount remaining (not used in previous rent increases)</span>
        </div>

        <div className="w1-step-three__wrapper">
          <span className="w1-step-three__value">{formatter.toAmountDisplay(calc_p1RentAmount)}</span>
          <span>Current monthly rent (before any rent increases in year)</span>
        </div>

        <div className="w1-step-three__wrapper">
          <span className="w1-step-three__value">{formatter.toAmountDisplay(calc_p2MaxCPIAmountStandardRentIncrease)}</span>
          <span>Maximum annual allowable rent increase amount {!cpiValue || !cpiYear ? null : `(${cpiValue * 100}% for ${cpiYear})` }</span>
        </div>

        <div className="w1-step-three__wrapper">
          <span className="w1-step-three__value">{formatter.toAmountDisplay(calc_p2MaxRentAmountStandardRentIncrease)}</span>
          <span>Rent amount with standard rent increase</span>
        </div>

        <div className="w1-step-three__wrapper">
          <span className="w1-step-three__value">{formatter.toAmountDisplay(calc_p2AppliedEligibleAmount)}</span>
          <span>Additional rent increase eligible amount for rent increase (max allowed 3% or {formatter.toAmountDisplay(calc_p2MaxEligibleAmount)})</span>
        </div>

        <div className="w1-step-three__wrapper">
          <span className="w1-step-three__value--result">{formatter.toAmountDisplay(calc_p2MaxAdditionalRentIncrease)}</span>
          <span>Maximum allowed rent amount with all rent increases applied</span>
        </div>
      </div>
    </>
  );
}

export default RICalcIncreaseBreakdown;